import React, { ReactNode } from 'react';
import _some from 'lodash/some';

// via https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/react/index.d.ts#L2886
type ReachChildrenToArrayType = Array<Exclude<ReactNode, boolean | null | undefined>>;
export function hasImage(childrenArr: ReachChildrenToArrayType): boolean {
  const cf = (child: React.ReactElement) => {
    return (
      React.isValidElement(child) &&
      (child.type === 'img' || (child.props as { src?: string })?.src)
    );
  };
  return _some(childrenArr, cf);
}
export function isPhotoCreditParagraph(childrenArr: ReachChildrenToArrayType): boolean {
  const cf = (child: React.ReactElement) => {
    if (child.type === 'em') {
      const grandchildrenArr = child.props?.children || [];
      const first = grandchildrenArr[0];
      if (first && typeof first === 'string' && first.indexOf('Photo Credit') > -1) {
        return true;
      }
    }
    // if not italicized
    if (child.props?.value?.indexOf('Photo Credit') > -1) {
      return true;
    }
    return false;
  };
  return _some(childrenArr, cf);
}
